import { inject, Injectable, LOCALE_ID } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { LanguageOption } from '../interface';
import { APP_CONSTANTS } from '../token';

@Injectable({
    providedIn: 'root',
})
export class LanguageService {
    private readonly locale = inject(LOCALE_ID);
    private readonly appConstants = inject(APP_CONSTANTS);
    private readonly cookieService = inject(CookieService);

    private normalizeLocaleId(localeId: string): string {
        return localeId === 'en-x-source' ? 'en' : localeId;
    }

    getCurrentLanguage(): LanguageOption | undefined {
        const normalizedLocale = this.normalizeLocaleId(this.locale);
        return this.getLanguages().find(lang => lang.code === normalizedLocale);
    }

    switchLanguage(newLanguage: string): void {
        this.setLanguageCookie(newLanguage);

        const currentLocation = window.location.href;
        let newLocation = '';

        if (currentLocation.endsWith(`/${this.locale}`)) {
            newLocation = currentLocation.replace(`/${this.locale}`, `/${newLanguage}/`);
        } else {
            newLocation = currentLocation.replace(`/${this.locale}/`, `/${newLanguage}/`);
        }
        window.location.href = newLocation;
    }

    getLanguages(): LanguageOption[] {
        return this.appConstants.environment.languageSettings?.languages ?? [];
    }

    private setLanguageCookie(language: string): void {
        if (!this.appConstants.languageCookieName) return;
        const expirationDate = new Date();
        expirationDate.setFullYear(expirationDate.getFullYear() + 1);

        this.cookieService.set(this.appConstants.languageCookieName, language, expirationDate, '/', undefined, true, 'Strict');
    }
}
